/* Shared keyboard and dialog behaviour. Commerce remains in AquonPurchase. */
(function () {
  'use strict';
  if (window.AquonPurchaseUI) return;
  var activeDialog = null;
  var focusSelector = 'button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex="0"]';

  function focusable(root) {
    return Array.from(root.querySelectorAll(focusSelector)).filter(function (el) {
      return el.getClientRects().length && !el.closest('[hidden], [inert]');
    });
  }

  // fallback (optional): an enabled control to focus on close when the trigger stays
  // unable to take focus (see returnFocus).
  function openDialog(dialog, close, fallback) {
    if (activeDialog && activeDialog.dialog === dialog) return;
    if (activeDialog) activeDialog.close();
    var state = {
      dialog: dialog,
      close: close,
      trigger: document.activeElement,
      fallback: fallback || null,
      overflow: document.documentElement.style.overflow,
      siblings: []
    };
    // Inert each sibling on the path to body; the active dialog stays interactive
    // even when it is nested inside a product section.
    var branch = dialog;
    while (branch.parentElement && branch !== document.body) {
      Array.from(branch.parentElement.children).forEach(function (sibling) {
        if (sibling !== branch && !sibling.inert) {
          sibling.inert = true;
          state.siblings.push(sibling);
        }
      });
      branch = branch.parentElement;
    }
    document.documentElement.style.overflow = 'hidden';
    document.documentElement.classList.add('aquon-purchase-dialog-open');
    dialog.setAttribute('tabindex', '-1');
    activeDialog = state;
    requestAnimationFrame(function () {
      if (activeDialog === state) (focusable(dialog)[0] || dialog).focus({ preventScroll: true });
    });
  }

  function closeDialog(dialog) {
    if (!activeDialog || activeDialog.dialog !== dialog) return;
    var state = activeDialog;
    activeDialog = null;
    state.siblings.forEach(function (el) { el.inert = false; });
    document.documentElement.style.overflow = state.overflow;
    document.documentElement.classList.remove('aquon-purchase-dialog-open');
    returnFocus(state);
  }

  function canFocus(el) {
    return !!el && el.isConnected && !el.disabled;
  }

  // Return focus to the control that opened the dialog. A trigger can refuse focus for a
  // moment: a sticky bar returning from visibility:hidden, or the sticky bar's button that
  // still mirrors the busy main CTA right after an add. Keep trying for a few frames, then
  // use the dialog's fallback control. Nothing is taken back once focus has moved on
  // (another dialog opened, checkout or the shopper moved it).
  function returnFocus(state) {
    var trigger = state.trigger;
    if (!trigger) return;
    if (canFocus(trigger)) {
      trigger.focus({ preventScroll: true });
      if (document.activeElement === trigger) return;
    }
    var frames = 0;
    function focusLost() {
      var current = document.activeElement;
      return !current || current === document.body || state.dialog.contains(current);
    }
    (function retry() {
      requestAnimationFrame(function () {
        if (activeDialog || !focusLost()) return;
        if (canFocus(trigger)) {
          trigger.focus({ preventScroll: true });
          if (document.activeElement === trigger) return;
        }
        if (++frames < 10) { retry(); return; }
        if (canFocus(state.fallback) && state.fallback !== trigger) state.fallback.focus();
      });
    })();
  }

  document.addEventListener('keydown', function (event) {
    if (!activeDialog) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      activeDialog.close();
      return;
    }
    if (event.key !== 'Tab') return;
    var controls = focusable(activeDialog.dialog);
    var first = controls[0], last = controls[controls.length - 1];
    if (!first) {
      event.preventDefault();
      activeDialog.dialog.focus();
    } else if (event.shiftKey && (document.activeElement === first || !activeDialog.dialog.contains(document.activeElement))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && (document.activeElement === last || !activeDialog.dialog.contains(document.activeElement))) {
      event.preventDefault();
      first.focus();
    }
  });

  function radioGroup(group, selector, selectedClass) {
    if (!group || group.dataset.aquonRadioReady === '1') return;
    group.dataset.aquonRadioReady = '1';
    group.setAttribute('role', 'radiogroup');
    var items = Array.from(group.querySelectorAll(selector));
    function sync() {
      var selected = items.find(function (item) { return item.classList.contains(selectedClass); }) || items[0];
      items.forEach(function (item) {
        item.setAttribute('role', 'radio');
        item.setAttribute('aria-checked', item === selected ? 'true' : 'false');
        item.tabIndex = item === selected ? 0 : -1;
      });
    }
    items.forEach(function (item, index) {
      item.addEventListener('click', sync);
      item.addEventListener('keydown', function (event) {
        if (event.key === ' ' || event.key === 'Enter') {
          if (item.tagName === 'BUTTON') return;
          event.preventDefault();
          item.click();
          return;
        }
        var target;
        if (event.key === 'Home') target = 0;
        else if (event.key === 'End') target = items.length - 1;
        else if (event.key === 'ArrowRight' || event.key === 'ArrowDown') target = (index + 1) % items.length;
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') target = (index - 1 + items.length) % items.length;
        else return;
        event.preventDefault();
        items[target].click();
        items[target].focus({ preventScroll: true });
        // Keep the newly focused radio in view (zoomed or short viewports, scrolling sheets);
        // 'nearest' does not move anything that is already fully visible.
        if (items[target].scrollIntoView) items[target].scrollIntoView({ block: 'nearest', inline: 'nearest' });
      });
    });
    sync();
    return sync;
  }

  document.addEventListener('shopify:section:unload', function (event) {
    if (activeDialog && event.target.contains(activeDialog.dialog)) closeDialog(activeDialog.dialog);
  });

  window.AquonPurchaseUI = { openDialog: openDialog, closeDialog: closeDialog, radioGroup: radioGroup };
})();
